import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';

const PainSection = () => {
  const { t } = useTranslation();

  const painPoints = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: 'Zettelwirtschaft und verzögerte Auftragsbearbeitung',
      description: 'Dein Außendienst notiert Bestellungen auf Papier, die erst später ins System übertragen werden – mit Verzögerungen und Fehlern.'
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: 'Veraltete Preis- und Lagerinformationen',
      description: 'Deine Verkäufer können Kunden nicht sofort aktuelle Preise oder Verfügbarkeiten nennen – führt zu Unsicherheit und verpassten Verkaufschancen.'
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      ),
      title: 'Doppelte Dateneingabe und Fehlerquellen',
      description: 'Bestelldaten müssen mehrfach erfasst werden: erst auf Papier, dann im ERP – eine potenzielle Fehlerquelle und Zeitverschwendung.'
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
        </svg>
      ),
      title: 'Fehlende Kundenhistorie unterwegs',
      description: 'Verkäufer haben keinen direkten Zugriff auf vergangene Bestellungen und Kundenpräferenzen – erschwert die persönliche Beratung und Cross-Selling.'
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01" />
        </svg>
      ),
      title: 'Unsichere Netzwerkverbindungen',
      description: 'Mobile Auftragserfassung scheitert an schlechtem Netz, wenn deine Lösung keine Offline-Funktionalität bietet.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900">
            Kennst du diese Probleme in deinem Außendienst?
          </h2>
          <p className="text-xl text-gray-700">
            Viele Unternehmen mit Außendienst kämpfen täglich mit diesen Herausforderungen – Salescockpit bietet die Lösung.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {painPoints.map((point, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-md hover:shadow-xl p-6 transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="mb-4">
                {point.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3 text-gray-900">
                {point.title}
              </h3>
              <p className="text-gray-700">
                {point.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <p className="text-xl font-semibold text-blue-700">
            Diese Probleme kosten dich nicht nur Zeit und Nerven – sondern auch bares Geld.
          </p>
          <div className="w-24 h-1 bg-blue-500 rounded-full mx-auto mt-4"></div>
        </div>
      </div>
    </section>
  );
};

export default PainSection; 